const LOCAL_MAKDIS_OS_ENDPOINT = "http://localhost:8787/api/intake";
const PRODUCTION_MAKDIS_OS_ENDPOINT = "https://api.makdis.io/api/intake";

const getBrowserHostname = () => {
  if (typeof window === "undefined") return false;
  return window.location?.hostname || "";
};

const isLocalHost = (hostname = getBrowserHostname()) => {
  return hostname === "localhost" || hostname === "127.0.0.1";
};

export const getMakdisOsEndpoint = ({ hostname } = {}) => {
  const configuredEndpoint = String(
    process.env.REACT_APP_MAKDIS_OS_API_URL || ""
  ).trim();

  if (configuredEndpoint) return configuredEndpoint;
  return isLocalHost(hostname)
    ? LOCAL_MAKDIS_OS_ENDPOINT
    : PRODUCTION_MAKDIS_OS_ENDPOINT;
};

export const getDiagnosticLifecycleStage = ({ routeFit, urgency }) => {
  const concreteRoute = routeFit && routeFit !== "unknown";
  const urgentEnough =
    urgency === "this-month" || urgency === "one-to-three-months";

  return concreteRoute && urgentEnough ? "Qualified" : "Lead";
};
